<script>

	import './style.scss'

	export default {
		name: 'page-template',
		props: ['center', 'direction']
	}

</script>

<template>
	<div v-bind:class="{ page: true, center }">
		<slot></slot>
	</div>
</template>



// WEBPACK FOOTER //
// src/containers/Page/Page.vue